export default __webpack_public_path__ + "media/images/lp/About-sp-da6d1df2b2ece1f068c8661accdbc95a.jpg";